export function formatDuration(millis: number | undefined): string {
  if (millis === undefined) {
    return '-'
  }
  if (Math.abs(millis) < 1000) {
    return `${millis}ms`
  }
  const seconds = Math.floor(Math.abs(millis) / 1000)
  const mins = Math.floor(seconds / 60)
  const hours = Math.floor(mins / 60)
  const days = Math.floor(hours / 24)
  const negative = millis < 0 ? -1 : 1

  if (days > 0) {
    return `${negative * days}d:${hours % 24}h:${mins % 60}m`
  }
  if (hours > 0) {
    return `${(negative * hours) % 24}h:${mins % 60}m`
  }
  if (mins > 0) {
    return `${(negative * mins) % 60}m:${seconds % 60}s`
  }

  return `${(negative * seconds) % 60}s`
}
